export default function StaticResume() {
  return (
    <div className="relative rounded-lg overflow-hidden shadow-lg border border-gray-300 bg-white">
      {/* PDF badge */}
      <div className="absolute top-3 right-3 z-10 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded uppercase tracking-wider">
        PDF
      </div>

      {/* Watermark overlay */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[5]">
        <span
          className="text-6xl font-bold tracking-[0.2em] whitespace-nowrap select-none"
          style={{
            color: 'rgba(0, 0, 0, 0.04)',
            transform: 'rotate(-35deg)',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          STATIC &bull; FLAT &bull; LOSSY
        </span>
      </div>

      {/* PDF Embed */}
      <div className="relative w-full" style={{ height: '600px' }}>
        <object
          data="/Ted_Lango_Resume.pdf"
          type="application/pdf"
          className="w-full h-full"
          title="Ted Lango Resume (PDF)"
        >
          <iframe
            src="/Ted_Lango_Resume.pdf"
            className="w-full h-full border-0"
            title="Ted Lango Resume (PDF)"
            style={{ backgroundColor: 'white' }}
          />
        </object>
      </div>

      {/* Bottom overlay to emphasize static nature */}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-100/90 to-transparent h-16 flex items-end justify-center pb-2">
        <span className="text-xs font-medium text-gray-600 bg-gray-200/80 px-3 py-1 rounded-full">
          Static Document • No Queryable Data • PDF Format
        </span>
      </div>
    </div>
  );
}
